import * as yup from "yup";

const schema = (translate: Function) => yup.object().shape({
	date: yup.date().required(translate("Validade é requerida")).min(
		yup.ref("today"),
		translate("Validade inválida")
	)
});

export default schema;

